// @flow

import React, { type Node } from 'react';
import { InputCardCvv } from '@tectonics/commons/look-and-feel/uber/molecule/input-card-cvv';
import { InputField } from '@tectonics/commons/look-and-feel/uber/molecule/input-field';
import { useUniqueId } from '@tectonics/hooks';
import { useUserInputAsTextField } from '@tectonics/prs/user-input-values';
import { useUserInputValidationError, type UserInputValidationError, serverErrorMessage } from '@tectonics/prs/validation';
import { useSubmitting } from '@tectonics/prs/submitting';

import { useFormHasBeenSent } from '@tectonics/prs/form-status';

export function VrPreTokenizedCardCvv(): Node {
  const inputId = useUniqueId();
  const submitting = useSubmitting();
  const [value, handleChange] = useUserInputAsTextField('mealVoucherVrPreTokenizedCardCvv');

  const formHasBeenSent = useFormHasBeenSent();
  const validationError = useUserInputValidationError('mealVoucherVrPreTokenizedCardCvv');

  return (
    <InputField
      fieldProps={{
        'data-test-name': 'customer-pre-tokenized-card-cvv',
      }}
      id={inputId}
      name="customer-pre-tokenized-card-cvv"
      label="Código de segurança"
      input={InputCardCvv}
      value={value}
      onChange={handleChange}
      error={formHasBeenSent && validationError ? cardCvvErrorMessage(validationError) : null}
      readyOnly={submitting}
    />
  );
}

function cardCvvErrorMessage(validationError: UserInputValidationError): string {
  if (validationError.id === 'empty') {
    return 'Preencha o código de segurança do cartão';
  }

  if (validationError.id === 'server-error') {
    return serverErrorMessage(validationError.payload);
  }

  return 'Código de segurança inválido';
}
